import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Utils } from '../utils';
import {
  ApplicationDeliveryStatus,
  ApplicationReceipt,
  applicationReceiptMessage,
} from '../shared/application-submission';

@Component({
    selector: 'applied',
    templateUrl: './applied.component.html',
    styleUrls: ['./applied.component.scss'],
    standalone: false
})
export class AppliedComponent implements OnInit {
  public message = applicationReceiptMessage('pending');
  public time = 10;
  public interval: any;
  public get countdown(): number {
    return this.time <= 0 ? 0 : this.time;
  }

  public constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly titleService: Title,
    private readonly cdr: ChangeDetectorRef,
    private readonly http: HttpClient,
  ) {}

  ngOnInit() {
    window.scrollTo(0, 0);
    this.titleService.setTitle('Blauwtand — Sollicitie succesvol!');
    const status = this.activatedRoute.snapshot.queryParamMap.get('status');
    const accepted: ApplicationDeliveryStatus[] = [
      'delivered',
      'pending',
      'checking',
      'manual_review',
    ];
    this.message = applicationReceiptMessage(
      accepted.includes(status as ApplicationDeliveryStatus)
        ? (status as ApplicationDeliveryStatus)
        : 'pending',
    );
    this.pollStoredReceipt();

    this.interval = setInterval(() => {
      this.time -= 1;
      if (this.time <= 0) {
        if (this.interval) {
          clearInterval(this.interval);
        }
        this.navigateTo('home');
      }
      this.cdr.markForCheck();
    }, 1000);
  }

  navigateTo(menuItem: string) {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (menuItem) {
      this.router.navigate([`../../../../${menuItem}`], {
        relativeTo: this.activatedRoute,
      });
    }
  }

  private pollStoredReceipt(attemptsRemaining = 6, delayMs = 1000): void {
    if (attemptsRemaining <= 0) return;
    let receipt: ApplicationReceipt | null = null;
    try {
      receipt = JSON.parse(
        sessionStorage.getItem('blauwtandApplicationReceipt') || 'null',
      ) as ApplicationReceipt | null;
    } catch {
      return;
    }
    if (!receipt || receipt.status === 'delivered') return;
    window.setTimeout(() => {
      this.http
        .get<ApplicationReceipt>(`${Utils.getApiUrl()}${receipt!.statusUrl}`, {
          headers: new HttpHeaders({
            'X-Receipt-Token': receipt!.receiptToken,
          }),
        })
        .subscribe({
          next: (updated) => {
            this.message = applicationReceiptMessage(updated.status);
            sessionStorage.setItem(
              'blauwtandApplicationReceipt',
              JSON.stringify(updated),
            );
            this.cdr.markForCheck();
            this.pollStoredReceipt(
              attemptsRemaining - 1,
              Math.min(delayMs * 2, 8000),
            );
          },
          error: () =>
            this.pollStoredReceipt(
              attemptsRemaining - 1,
              Math.min(delayMs * 2, 8000),
            ),
        });
    }, delayMs);
  }
}
